import React, { useEffect, useRef, useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import EventEHRSimpleCard from "../../component-lib/Molecules/card/EventEHRSimpleCard";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import useHasOverflow from "../../custom-hooks/HasOverflow";
import { useAutoRefresh } from "../../custom-hooks/useAutoRefresh";
import EventEHRItemListCard from "../../component-lib/Molecules/card/EventEHRItemListCard";
import {
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
  getStockStatusBackground,
  getStockStatusDotColor,
  getStockStatusTextColor,
} from "../../utils/statusConstants";
import { getLoginUserData } from "../../utils/getToken";
import { capitalizeName } from "../../utils/capitalizeName";
import { useNavigate, useParams } from "react-router-dom";
import { formatPhoneNumber } from "../../utils/phoneNumberFormatter";
import EventEHRSwitchButton from "../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacilityList,
  getPatientList,
  patchFacilityData,
  deleteFacility,
} from "../facility-management-screen/FacilityManagementSaga";
import {
  componentKey,
  setCloseAddFacilityDialog,
  setCloseCreatePatientDrawer,
  setDeleteFacilityResponse,
} from "../facility-management-screen/FacilityManagementSlice";
import {
  componentKey as componentKeyInventory,
  setCloseInventoryDialog,
} from "../inventory-screen/InventorySlice";
import { getInventoryList } from "../inventory-screen/InventorySaga";

import { componentKey as componentKeyDashboard } from "./DashboardSlice";
import { getDashboardData, getDataForFacilities } from "./DashboardSaga";
import { componentKey as componentKeyOrder } from "../orders-screen/orderSlice";
import { getOrderList } from "../orders-screen/orderSaga";
import EventEHRToggleTabButton from "../../component-lib/Molecules/toggle-tab-button/EventEHRToggleTabButton";
import Bar from "../../component-lib/Organisms/charts/BarChart";
import { getInventoryData } from "../inventory-screen/contstant";
import ViewInventoryDialog from "../inventory-screen/dialogs/ViewInventoryDialog";
import IcdCodesCard from "./icd-card/IcdCodesCard";
import Button from "../../component-lib/Molecules/button/Button";
import SelectDropdown from "../../component-lib/Atoms/Select/Select";
import { Dashboard } from "@mui/icons-material";
import FacilityDashboard from "./Facility-Dashboard-Screen/FacilityDashboard";
import DeleteFacilityConfirmationDialog from "./dialogs/DeleteFacilityConfirmationDialog";

const DashboardScreen = () => {
  const {
    facilityList,
    closeAddFacilityDialog,
    patientListData,
    closeCreatePatientDrawer,
    deleteFacilityResponse,
  } = useSelector((state: any) => state[componentKey]);

  const { inventoryList, closeInventoryDialog } = useSelector(
    (state: any) => state[componentKeyInventory]
  );

  const { orderListData } = useSelector(
    (state: any) => state[componentKeyOrder]
  );

  const { dashboardData } = useSelector(
    (state: any) => state[componentKeyDashboard]
  );

  const showCampDoc = dashboardData?.camDoc?.sso || true;

  const { facilityId } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rowPerPage, setRowPerPage] = useState("5");
  const [pageNumber, setPageNumber] = useState(1);
  const [facility, setFacility] = useState("");
  const loginUserData: any = getLoginUserData();
  const parsedLoginUserData = JSON.parse(loginUserData);
  const loggedInUserName = capitalizeName(parsedLoginUserData?.name);

  const [openViewInventoryDialog, setOpenViewInventoryDialog] = useState(false);
  const [defaultDataForInventory, setDefaultDataForInventory] = useState<any>(
    {}
  );

  // THIS IS THE STATE TO SWITCH TOGGLEpatchFacilityData INSIDE USER TAB
  const [selectedTabForUser, setSelectedTabForUser] = useState("Dashboard");
  const [openFacilityDailog, setOpenFacilityDailog] = useState(false);
  const [defaultPassData, setDefaultPassData] = useState<any>({});
  // Bumped by the 30s auto-refresh so the ICD card re-pulls its own window
  // without the dashboard needing to know which period the card is showing.
  const [icdRefreshKey, setIcdRefreshKey] = useState(0);
  const divRef = useRef<HTMLDivElement>(null);
  const hasOverflow = useHasOverflow(divRef);

  // Delete facility states
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false);
  const [deleteFacilityData, setDeleteFacilityData] = useState<any>(null);
  const [deleteResponseData, setDeleteResponseData] = useState<any>(null);

  // Recent patient list data
  const patientListItemsData = patientListData?.patient?.map((data: any) => ({
    title: `${data?.participant?.firstName || ""} ${data?.participant?.lastName || ""}`,
    subTitle: "BSA ID:",
    valueOfSubTitle: data?.participant?.bsaId || "",
    imgURL: data?.participant?.profilePicture,
    status: data?.status || "",
    id: data?.id,
  }));

  // Recent order list data
  const orderListItemsData = orderListData?.data?.map((data: any) => ({
    title: data?.inventory?.itemName || "",
    subTitle: "Order ID:",
    valueOfSubTitle: data?.orderId || "",
    status: data?.orderStatus?.split("_").join(" ") || "",
  }));

  // Recent low stock alerts list data
  const lowStockAlertsListItemsData = inventoryList?.lowStocksInventory?.map(
    (data: any) => ({
      title: data?.itemName || "",
      subTitle: "Item ID:",
      valueOfSubTitle: data?.itemCode || "",
      status: data?.status?.split("_").join(" ") || "",
    })
  );

  // Dashboard simple cards data
  const dashboardCardsData = [
    {
      title: "Total Facilities",
      value: dashboardData?.totalCount?.facility || "0",
    },
    {
      title: "Total Patients",
      value: dashboardData?.totalCount?.patient || "0",
    },
    {
      title: "Total Providers",
      value: dashboardData?.totalCount?.provider || "0",
    },
    { title: "Total Staff", value: dashboardData?.totalCount?.staff || "0" },
    { title: "Total Admins", value: dashboardData?.totalCount?.admin || "0" },
    {
      title: "Total Super Admins",
      value: dashboardData?.totalCount?.superadmin || "0",
    },
  ];

  // Inventory simple cards data
  const inventoryCardsData = [
    {
      title: "Total Inventory",
      value: inventoryList?.count?.totalStocks || "0",
    },
    { title: "In Stock", value: inventoryList?.count?.inStock || "0" },
    { title: "Low Stock", value: inventoryList?.count?.lowStock || "0" },
    { title: "Out of Stock", value: inventoryList?.count?.outOfStock || "0" },
  ];

  // HANDLE DELETE FACILITY
  const handleDeleteFacility = (row: any) => {
    setDeleteFacilityData(row);
    setDeleteResponseData(null);
    // Clear previous response
    dispatch(setDeleteFacilityResponse(null));
    
    // First call with force=false
    dispatch(
      deleteFacility({
        facilityId: row?.id,
        force: false,
      })
    );
  };

  const facilityManagementColumns = [
    {
      field: "Facility",
      label: <div>Facility</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="font-medium text-primary-main cursor-pointer common-text-ellipse-style "
            onClick={() => {
              navigate(`/facility-management/${row?.id}`);
            }}
          >
            {" "}
            {row?.facility}
          </p>
        );
      },
    },
    {
      field: "numberOfDepartment",
      label: <div>No. of Departments</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.noOfDepartment}
          </p>
        );
      },
    },
    {
      field: "numberOfPatient",
      label: <div>No. of Patients</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="font-medium text-primary-main cursor-pointer common-text-ellipse-style "
            onClick={() => {
              navigate(
                `/facility-management/${row?.id}?selectedPatient=patient`
              );
            }}
          >
            {" "}
            {row?.noOfPatient}
          </p>
        );
      },
    },
    {
      field: "numberOfUsers",
      label: <div>No. of User's</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.numberOfUsers}
          </p>
        );
      },
    },
    {
      field: "order count",
      label: <div>Order Count</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.orderCount}</p>;
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const apiPayload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  facilityId: row?.id,
                };
                dispatch(patchFacilityData(apiPayload));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Facility Details",
                    onClickCb: () => {
                      navigate(`/facility-management/${row?.id}`);
                    },
                  },
                  {
                    label: "Delete Facility",
                    onClickCb: () => {
                      handleDeleteFacility(row);
                    },
                  },
                  // {
                  //   label: "Edit Facility",
                  //   onClickCb: () => {
                  //     // setDefaultFacilityDataRow(row);
                  //     // setOpenAddFacilityDialog(true);
                  //   },
                  // },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // ALL INVENTORY COLUMN DATA
  const allInventoryTabColumns = [
    {
      field: "itemID",
      label: <div>Item ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.itemID}</p>;
      },
    },
    {
      field: "itemName",
      label: <div>Item Name</div>,
      renderLogic: (row: any) => {
        return <p className=" text-neutral-90 font-normal">{row?.itemName}</p>;
      },
    },
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.category}</p>;
      },
    },
    {
      field: "currentStock",
      label: <div>Current Stock</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.currentStock}</p>
        );
      },
    },
    {
      field: "reorderPoint",
      label: <div>Reorder Point</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.reorderPoint}</p>
        );
      },
    },
    {
      field: "status",
      label: <div>Stock Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1"
              style={{
                color: getStockStatusTextColor(row?.status),
                background: getStockStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <img
                src={getStockStatusDotColor(row?.status)}
                alt={row?.status}
              />
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Inventory",
                    onClickCb: () => {
                      setDefaultDataForInventory(row);
                      setOpenViewInventoryDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // FACILITY DASHBOARD API'S ----------------------------------- //

  const facilityManagementData = facilityList?.facilitys?.map((data: any) => ({
    facility: data?.name || "-",
    facilityAdmin: data?.contactPerson || "-",
    noOfDepartment: data?.numberOfDepartments || "0",
    noOfPatient: data?._count?.patient || "0",
    // location: data?.address?.addressLine1
    //   ? mapAddressToLocation(data?.address)
    //   : "-",
    contactNumber: data?.contactNumber || "-",
    status: data?.status || false,
    id: data?.id,
    data: data,
    orderCount: data?._count?.facility_order_inventory,
    numberOfUsers: data?._count?.user,
  }));

  useEffect(() => {
    getFacility();
    getPatients();
    getDashboard();
  }, [rowPerPage, pageNumber]);

  useEffect(() => {
    if (closeAddFacilityDialog) {
      dispatch(setCloseAddFacilityDialog(false));
      getFacility();
    }

    if (closeCreatePatientDrawer) {
      dispatch(setCloseCreatePatientDrawer(false));
      getPatients();
    }
  }, [closeAddFacilityDialog, closeCreatePatientDrawer]);

  // GET FACILITY LIST
  const getFacility = (silent = false) => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      silent,
    };
    dispatch(getFacilityList(payload));
  };

  // GET PATIENT LIST
  const getPatients = (silent = false) => {
    const payload = {
      pageNumber: 1,
      // searchKey: searchedValue?.trim(),
      limit: "5",
      facilityId: facilityId,
      silent,
    };
    dispatch(getPatientList(payload));
  };

  // GET DASHBOARD LIST
  const getDashboard = (silent = false) => {
    const payload = {
      start: "",
      end: "",
      silent,
    };
    dispatch(getDashboardData(payload));
  };

  // INVENTORY DASHBOARD API'S --------------------------------------------- //

  useEffect(() => {
    getInventory();
    getOrder();
  }, [rowPerPage, pageNumber]);

  useEffect(() => {
    if (closeInventoryDialog) {
      dispatch(setCloseInventoryDialog(false));
      getInventory();
    }
  }, [closeInventoryDialog]);

  // INVENTORY LIST ROW DATA
  const inventoryRowData = getInventoryData(inventoryList);

  // GET INVENTORY LIST
  const getInventory = (silent = false) => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      dashboard: "true",
      silent,
    };
    dispatch(getInventoryList(payload));
  };

  // OERDER LIST
  const getOrder = (silent = false) => {
    const payload = {
      pageNumber: 1,
      limit: "5",
      // searchKey: searchedValue?.trim(),
      silent,
    };
    dispatch(getOrderList(payload));
  };

  // Auto-refresh: silently re-fetch the active main-dashboard view every 30s
  // (no full-screen spinner). Only the visible tab's APIs poll; paused while a
  // facility is selected (FacilityDashboard polls itself) and while a dialog is
  // open. Tab-hidden pausing is handled inside the hook.
  const isMainDashboardDialogOpen =
    openViewInventoryDialog || openDeleteConfirmationDialog;

  useAutoRefresh(
    () => {
      if (selectedTabForUser === "Dashboard") {
        getFacility(true);
        getPatients(true);
        getDashboard(true);
        setIcdRefreshKey((key) => key + 1);
      } else if (selectedTabForUser === "Inventory Dashboard") {
        getInventory(true);
        getOrder(true);
      }
    },
    {
      intervalMs: 30000,
      enabled: !facility && !isMainDashboardDialogOpen,
    }
  );

  const options = dashboardData?.facility?.map(
    (facility: { id: string; name: string }) => ({
      value: facility.id,
      label: facility.name,
    })
  );

  // Watch for delete facility response
  useEffect(() => {
    if (deleteFacilityResponse && deleteFacilityData) {
      const responseData = deleteFacilityResponse.data;
      const wasForceDelete = deleteFacilityResponse.force === true;
      
      if (wasForceDelete) {
        // Force delete was called - check if it succeeded
        if (deleteFacilityResponse.success === true || responseData?.success === true) {
          // Force delete succeeded, close dialog and refresh
          setOpenDeleteConfirmationDialog(false);
          setDeleteFacilityData(null);
          setDeleteResponseData(null);
          dispatch(setDeleteFacilityResponse(null));
          // Refresh facility list
          getFacility();
          // Also refresh dashboard
          getDashboard();
        }
      } else if (!wasForceDelete) {
        // First call (force=false) - always show confirmation dialog
        // Whether success is true or false, we show confirmation
        setDeleteResponseData(responseData);
        setOpenDeleteConfirmationDialog(true);
      }
    }
  }, [deleteFacilityResponse, deleteFacilityData]);

  // HANDLE DELETE CONFIRMATION
  const handleDeleteConfirmation = (action: "cancel" | "delete") => {
    if (action === "cancel") {
      setOpenDeleteConfirmationDialog(false);
      setDeleteFacilityData(null);
      setDeleteResponseData(null);
      dispatch(setDeleteFacilityResponse(null));
      return;
    }

    // User confirmed deletion
    if (deleteFacilityData) {
      // Clear previous response before new call
      dispatch(setDeleteFacilityResponse(null));
      
      dispatch(
        deleteFacility({
          facilityId: deleteFacilityData?.id,
          force: true,
        })
      );
    }
  };

  return (
    <WrapperCard customClasses="m-3 p-3 flex-1 min-h-0 flex flex-col overflow-auto">
      <div className="flex flex-wrap gap-3 justify-between items-center mb-4">
        {/* Login user Welcome Message */}
        <Heading
          title={`Welcome, ${loggedInUserName}`}
          customStyle={{ color: "#393939", fontSize: "20px" }}
        />
        <div className="flex flex-wrap items-center gap-2 w-full xl:w-auto xl:justify-end">
          {!showCampDoc && (
            <Button
              label="CampDoc"
              variant="contained"
              onClickCb={() => {
                window?.open(dashboardData?.camDoc?.link, "_blank"); // Opens in a new tab
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
                height: "38px",
                background: "#b10909",
                border: "1px solid #b10909",
              }}
            ></Button>
          )}
          <div style={{ maxWidth: "350px" }}>
            <SelectDropdown
              label=""
              name="facility"
              placeholderValue="All Facilities"
              displayEmpty={true}
              value={facility}
              options={options}
              onChangeCb={(e) => {
                setPageNumber(1);
                if (e.target.value !== "") {
                  setSelectedTabForUser("");
                } else {
                  setSelectedTabForUser("Dashboard");
                }
                const selectedFacility = options?.find(
                  (options: any) => options?.value === e.target.value
                );
                setDefaultPassData(selectedFacility);
                setOpenFacilityDailog(true);
                setFacility(e.target.value);
              }}
            />
          </div>
          <EventEHRToggleTabButton
            customWidth="350px"
            defaultSelected={selectedTabForUser}
            tabs={["Dashboard", "Inventory Dashboard"]}
            onToggle={(value) => {
              if (value === "Dashboard" || value === "Inventory Dashboard") {
                setFacility("");
                setDefaultPassData({});
              }
              setSelectedTabForUser(value);
              setOpenFacilityDailog(false);
              setPageNumber(1);
              setTimeout(() => {
                setRowPerPage("5");
              }, 100);
            }}
            variant="contained"
          />
        </div>
      </div>

      <div
        ref={divRef}
        className={`overflow-auto flex-1 min-h-0 ${hasOverflow ? "pr-2" : "0"}`}
      >
        {facility && facility !== "All Facility" ? (
          <FacilityDashboard defaultData={defaultPassData} />
        ) : selectedTabForUser === "Dashboard" ? (
          <>
            {/* Dashboard cards */}
            <div className="flex w-full gap-3 mb-4">
              <EventEHRSimpleCard
                cardData={dashboardCardsData}
                handleClick={(data) => {}}
              />
            </div>

            {/* Recent Patients, ICD/DSM Codes and the visits graph — three
                equal columns (the ICD card takes half of the space Recent
                Patients used to have). */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "20px",
              }}
            >
              <EventEHRItemListCard
                cardTitle="Recent Patients"
                listItemsData={patientListItemsData}
                // itemsActionButtonName="View Profile"
                showStatus={true}
                getStatusDotColor={getStatusDotColor}
                getStatusBackground={getStatusBackground}
                getStatusTextColor={getStatusTextColor}
                handleItemsABClick={(data) => {
                  // navigate(`/facility-management/${data?.id}`);
                }}
                handleViewAllClick={() => {
                  // navigate(`/facility-management`);
                }}
                noDataDataFoundMessage="No Recent Orders Found "
              />

              {/* ICD-10 / DSM codes being seen, by facility */}
              <IcdCodesCard refreshKey={icdRefreshKey} />

              <div className="flex justify-center items-center p-3 border-1px-solid-D2D2D2 rounded w-full">
                <Bar />
              </div>
            </div>
            {/* All Facility Table Data */}
            <div className="mt-4">
              <Heading
                title="Facility List"
                customStyle={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#565656",
                }}
              />
              <div className="mt-2">
                <Table
                  columns={facilityManagementColumns}
                  rows={facilityManagementData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: facilityList?.totalPages,
                    totalCount: facilityList?.totalRecords,
                    limit: rowPerPage,
                    rowsPerPageOptions: [5, 10, 25],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Dashboard cards */}
            <div className="flex w-full gap-3 mb-4">
              <EventEHRSimpleCard
                cardData={inventoryCardsData}
                handleClick={(data) => {}}
              />
            </div>

            {/* Recent Orders  and Low Stock Alerts */}
            <div className="flex flex-row gap-3">
              {
                <EventEHRItemListCard
                  cardTitle="Recent Orders"
                  listItemsData={orderListItemsData}
                  // itemsActionButtonName="View Profile"
                  showStatus={true}
                  getStatusDotColor={getStatusDotColor}
                  getStatusBackground={getStatusBackground}
                  getStatusTextColor={getStatusTextColor}
                  handleItemsABClick={(data) => {}}
                  handleViewAllClick={() => {
                    navigate(`/orders`);
                  }}
                  actionViewAll={true}
                  view={"withoutImage"}
                  noDataDataFoundMessage="No Recent Orders Found "
                />
              }
              <EventEHRItemListCard
                cardTitle="Low Stock Alerts"
                // itemsActionButtonName="View Details"
                listItemsData={lowStockAlertsListItemsData}
                showStatus={true}
                getStatusDotColor={getStatusDotColor}
                getStatusBackground={getStatusBackground}
                getStatusTextColor={getStatusTextColor}
                handleItemsABClick={(data) => {}}
                handleViewAllClick={() => {
                  navigate(`/inventory-management?selectedStock=lsa`);
                }}
                actionViewAll={true}
                view={"withoutImage"}
                noDataDataFoundMessage="No Low Stock Alerts Found "
              />
            </div>
            {/* All Inventory Table Data */}
            <div className="mt-4">
              <div className="flex justify-between items-center">
                <Heading
                  title="All Inventory"
                  customStyle={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#565656",
                  }}
                />
                <Button
                  label="View All"
                  variant="text"
                  onClickCb={() => {
                    navigate(`/inventory-management`);
                  }}
                  style={{}}
                ></Button>
              </div>

              <div className="mt-2">
                <Table
                  columns={allInventoryTabColumns}
                  rows={inventoryRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: inventoryList?.totalPages,
                    totalCount: inventoryList?.totalRecords,
                    limit: rowPerPage,
                    rowsPerPageOptions: [5, 10, 25],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
      {openViewInventoryDialog && (
        <ViewInventoryDialog
          dialogHeading="View Inventory Details"
          handleClose={() => setOpenViewInventoryDialog(false)}
          inventoryData={defaultDataForInventory}
          isOpen={openViewInventoryDialog}
        />
      )}

      {openDeleteConfirmationDialog && (
        <DeleteFacilityConfirmationDialog
          isOpen={openDeleteConfirmationDialog}
          dialogHeading="Delete Facility"
          handleClose={handleDeleteConfirmation}
          facilityName={deleteFacilityData?.facility || deleteResponseData?.facility?.name}
          relatedData={deleteResponseData?.relatedData}
          warning={deleteResponseData?.warning}
          message={deleteResponseData?.message}
        />
      )}
    </WrapperCard>
  );
};

export default DashboardScreen;
